import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { content } from './shared/routes/content-routes';
import { ContentLayoutComponent } from './shared/layout/content-layout/content-layout.component';
import { LoginComponent } from './components/auth/login/login.component';
import { SignUpComponent } from './components/auth/sign-up/sign-up.component';
import { ThanksComponent } from './components/auth/thanks/thanks.component';
import { ActivateComponent } from './components/auth/activate/activate.component';
import { HomeComponent } from './components/auth/home/home.component';
import { ReportComponent } from './components/auth/report/report.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { WorkOrdertoPDFComponent } from './components/work-orders/work-order-toPdf/work-order-toPdf.component';
import { ViewTripComponent } from './components/trips/view-trip/view-trip.component';
import { CiudadanoLayoutComponent } from './shared/layout/ciudadano-layout/ciudadano-layout.component';
import { AdminAuthGuard } from './shared/service/admin-auth.guard';

const routes: Routes = [
  // ── Redirect raíz: redirige '/' al portal ciudadano ───────────────────────
  { path: '', redirectTo: '/ciudadano', pathMatch: 'full' },

  // ── Rutas nombradas (deben ir ANTES de los catch-all con path:'') ──────────

  // Login backoffice
  { path: 'admin',                    component: LoginComponent },
  { path: 'reporte',                  component: ReportComponent },
  { path: 'reporte-ciudadano',        component: HomeComponent },
  { path: 'registro',                 component: SignUpComponent },
  { path: 'registro-exitoso',         component: ThanksComponent },
  { path: 'activar-cuenta/:uuid',     component: ActivateComponent },
  { path: 'recuperar-contrasena',     component: ForgotPasswordComponent },
  { path: 'restablecer-contrasena/:token', component: ResetPasswordComponent },
  { path: 'download/:id',             component: WorkOrdertoPDFComponent },
  { path: 'download-report/:id',      component: WorkOrdertoPDFComponent },
  { path: 'download-reportEvent/:id', component: WorkOrdertoPDFComponent },
  { path: 'view-Trip/:tripId',        component: ViewTripComponent },

  // Alias: URL publicada con typo (suscribeme → suscribirme)
  {
    path: 'ciudadano/limpia-publica/suscribeme',
    redirectTo: 'ciudadano/limpia-publica/suscribirme',
    pathMatch: 'full',
  },

  // Portal ciudadano (rutas bajo /ciudadano/...)
  {
    path: 'ciudadano',
    component: CiudadanoLayoutComponent,
    loadChildren: () => import('../app/components/ciudadano/ciudadano.module').then(m => m.CiudadanoModule),
  },
  // Vista pública: reportes atendidos (sin layout — pantalla completa)
  {
    path: 'reportes-atendidos',
    loadChildren: () => import('../app/components/reportes-atendidos/reportes-atendidos.module').then(m => m.ReportesAtendidosModule),
  },
  // Vista pública: reportes ciudadanos MySQL (sin layout — pantalla completa)
  {
    path: 'reportes-ciudadanos',
    loadChildren: () => import('../app/components/reportes-ciudadanos/reportes-ciudadanos.module').then(m => m.ReportesCiudadanosModule),
  },
  // Vista pública: mapa de calor por zonas de calidad del agua
  {
    path: 'reportes-ciudadanos-zonas',
    loadChildren: () => import('../app/components/reportes-ciudadanos-zonas/reportes-ciudadanos-zonas.module').then(m => m.ReportesCiudadanosZonasModule),
  },
  // Vista pública: monitor de limpia pública (sin auth, sin layout)
  {
    path: 'monitor-limpia-publica',
    loadChildren: () => import('../app/components/monitor-limpia-publica/monitor-limpia-publica.module').then(m => m.MonitorLimpiaPublicaModule),
  },
  // Vista pública: suscribirse a limpia pública (URL corta sin prefijo /ciudadano)
  {
    path: 'limpia-publica/suscribeme',
    redirectTo: 'limpia-publica/suscribirme',
    pathMatch: 'full',
  },
  {
    path: 'limpia-publica/suscribirme',
    component: CiudadanoLayoutComponent,
    loadChildren: () => import('../app/components/ciudadano/ciudadano.module').then(m => m.CiudadanoModule),
  },

  // Módulos con rutas propias
  { path: 'settings',  loadChildren: () => import('../app/components/setting/setting.module').then(m => m.SettingModule),   data: { breadcrumb: 'Ajustes' } },
  { path: 'empleos',   loadChildren: () => import('../app/components/jobs/jobs.module').then(m => m.JobsModule),            data: { breadcrumb: 'Empleos' } },
  { path: 'tramites',  loadChildren: () => import('../app/components/catalogs/catalogs.module').then(m => m.CatalogsModule), data: { breadcrumb: 'Trámites' } },
  // /catalogs → definido en content-routes.ts bajo ContentLayout (header + sidebar).
  // No duplicar aquí: una ruta raíz 'catalogs' cargaba el módulo sin layout.

  // ── Backoffice con sidebar (rutas en content-routes.ts) ───────────────────
  // DEBE ir antes de la ruta raíz ciudadana para que /inicio, /reports, etc. funcionen
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [AdminAuthGuard],
    children: content
  },

  // ── Ruta raíz: portal ciudadano (catch-all, va AL FINAL) ─────────────────
  {
    path: '',
    component: CiudadanoLayoutComponent,
    loadChildren: () => import('../app/components/ciudadano/ciudadano.module').then(m => m.CiudadanoModule),
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
